import { Instagram, Mail, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#161618] text-[#F1EDDE] pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <h3
            className="font-serif text-3xl sm:text-4xl text-[#F1EDDE] leading-tight tracking-tight"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Stacy Fox
            <span className="block font-light italic text-[#B6AA96] text-xl sm:text-2xl mt-1">
              Laser &amp; Advanced Aesthetics
            </span>
          </h3>
          <p className="mt-8 max-w-sm text-[#B6AA96] font-light leading-relaxed">
            A private medical aesthetics practice built on restraint, anatomy
            and an eye for natural-looking results.
          </p>
        </div>

        <div className="lg:col-span-3">
          <div className="text-[0.65rem] uppercase tracking-[0.3em] text-[#B6AA96] mb-4">
            Visit
          </div>
          <p className="text-[#E6DFCC] font-light leading-relaxed">
            By appointment only<br />
            Cumbria · Manchester
          </p>
        </div>

        <div className="lg:col-span-2">
          <div className="text-[0.65rem] uppercase tracking-[0.3em] text-[#B6AA96] mb-4">
            Explore
          </div>
          <ul className="space-y-2 text-[#E6DFCC] font-light">
            <li><a href="#treatments" className="hover:text-[#B6AA96]">Treatments</a></li>
            <li><a href="#membership" className="hover:text-[#B6AA96]">Membership</a></li>
            <li><a href="#about" className="hover:text-[#B6AA96]">About</a></li>
            <li><a href="#contact" className="hover:text-[#B6AA96]">Contact</a></li>
          </ul>
        </div>

        <div className="lg:col-span-2">
          <div className="text-[0.65rem] uppercase tracking-[0.3em] text-[#B6AA96] mb-4">
            Connect
          </div>
          <ul className="space-y-3 text-[#E6DFCC] font-light">
            <li className="flex items-center gap-2">
              <Instagram className="w-4 h-4 text-[#B6AA96]" />
              <a href="#" className="hover:text-[#B6AA96]">@stacyfoxaesthetics</a>
            </li>
            <li className="flex items-center gap-2">
              <Mail className="w-4 h-4 text-[#B6AA96]" />
              <a
                href="mailto:sfaesthetics20@gmail.com"
                data-testid="footer-email-link"
                className="hover:text-[#B6AA96]"
              >
                sfaesthetics20@gmail.com
              </a>
            </li>
            <li className="flex items-center gap-2">
              <MapPin className="w-4 h-4 text-[#B6AA96]" />
              <span>Cumbria · Manchester</span>
            </li>
            <li className="flex items-center gap-2">
              <span className="w-4 h-4 inline-flex items-center justify-center text-[#B6AA96] text-xs">☎</span>
              <a
                href="tel:+447513616311"
                data-testid="footer-phone-link"
                className="hover:text-[#B6AA96]"
              >
                07513 616 311
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 sm:px-10 mt-16 pt-8 border-t border-[#4D4A47] flex flex-col sm:flex-row items-center justify-between gap-4">
        <span className="text-[0.65rem] uppercase tracking-[0.25em] text-[#8C8580]">
          © {new Date().getFullYear()} Stacy Fox Aesthetics · All rights reserved.
        </span>
        <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-6">
          <Link
            to="/terms"
            data-testid="footer-terms-link"
            className="text-[0.65rem] uppercase tracking-[0.25em] text-[#8C8580] hover:text-[#F1EDDE] transition-colors"
          >
            Terms & Conditions
          </Link>
          <Link
            to="/privacy"
            data-testid="footer-privacy-link"
            className="text-[0.65rem] uppercase tracking-[0.25em] text-[#8C8580] hover:text-[#F1EDDE] transition-colors"
          >
            Privacy Policy
          </Link>
          <span className="text-[0.65rem] uppercase tracking-[0.25em] text-[#8C8580]">
            Registered aesthetic practice · JCCP member
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
